import React from "react";
import { CustomPicker } from "react-color";
import {
  EditableInput,
  Hue,
  Saturation,
} from "react-color/lib/components/common";
import { ColorPickerContainer, HexInputContainer } from "./styles";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { hexadecimalMask } from "../../services/Masks";
import { validateHex } from "../../services/MasksValidations";
import ColorDisplay from "../ColorDisplay/ColorDisplay";
import { Input } from "../Input";

export const MyPicker = ({
  hex,
  hsl,
  hsv,
  onChange,
  color,
  onChangeInput,
  // Amostra da cor escolhida ao lado do Hex, no mesmo desenho do bloco de cores
  // da marca. Opt-in porque lá o preview já existe fora do picker.
  mostrarPreview = false,
}) => {
  const { theme } = useTheme();

  const onChangeEditableInput = (newValue: string) => {
    onChangeInput(newValue);
  };

  // Hex pela metade não vira cor: pintar com ele deixaria a amostra transparente
  // no meio da digitação. Por isso a última válida fica guardada até fechar os 6 dígitos.
  const ultimaCorValida = React.useRef<string | undefined>(undefined);
  const hexAtual = hexadecimalMask(color);
  if (validateHex(hexAtual)) ultimaCorValida.current = hexAtual;
  const corPreview = ultimaCorValida.current;

  // Dentro da pílula o hex é o próprio .color-code das configs, só que editável.
  // O componente Input não serve aqui: ele traz campo completo (fundo, 6rem de
  // altura, cantos de 10rem) com especificidade maior que qualquer override, e
  // desmancharia o desenho. A máscara é a mesma, aplicada na digitação.
  const campoHex = mostrarPreview ? (
    // Sem maxLength de propósito: colar "#4608AD" por cima de "FFFFFF" (com o "#"
    // do campo preservado) daria 8 caracteres, e o navegador cortaria a colagem
    // ANTES da máscara rodar, sobrando um hex incompleto. A máscara já limita a 6
    // dígitos, então o valor nunca passa de 7 caracteres de qualquer forma.
    <input
      className="color-code fonteHex"
      value={hexAtual}
      placeholder="#000000"
      onChange={(evento) =>
        onChangeEditableInput(hexadecimalMask(evento.target.value))
      }
    />
  ) : (
    <Input
      value={hexAtual}
      type="text"
      onChange={onChangeEditableInput}
      mask={{
        mask: hexadecimalMask,
      }}
      placeholder="#000000"
    />
  );

  return (
    <>
      <ColorPickerContainer theme={theme}>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "2rem",
          }}
        >
          <div
            style={{
              width: 150,
              height: 150,
              position: "relative",
              MozWindowDragging: "no-drag",
              cursor: "crosshair",
            }}
          >
            <Saturation
              hsl={hsl}
              hsv={hsv}
              onChange={onChange}
              pointer={() => {
                return (
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      border: `2px solid white`,
                      outline: "1px solid black",
                      backgroundColor: "trasparent",
                      position: "absolute",
                      top: "-5px",
                      left: "-5px",
                      cursor: "crosshair",
                      MozWindowDragging: "no-drag",
                    }}
                  ></div>
                );
              }}
            />
          </div>
          <div
            style={{
              height: 150,
              width: 20,
              position: "relative",
            }}
          >
            <Hue
              direction={"vertical"}
              hsl={hsl}
              onChange={onChange}
              pointer={() => {
                return (
                  <div
                    style={{
                      width: 20,
                      height: 5,
                      backgroundColor: "#FFFFFF",
                      border: `1px solid black`,
                      boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.25)",
                    }}
                  ></div>
                );
              }}
            />
          </div>
        </div>
        <HexInputContainer theme={theme}>
          <div className="label fonteTexto">Hex</div>
          {mostrarPreview ? (
            // Mesma pílula das cores da marca, com o campo editável no lugar do
            // código — aqui o hex já é o que se edita.
            // Sem a classe input-hex-container de propósito: o modal força 100%
            // nela, e a pílula precisa encolher no conteúdo como nas configs.
            <ColorDisplay cor={corPreview}>{campoHex}</ColorDisplay>
          ) : (
            <div className="input-hex-container">{campoHex}</div>
          )}
        </HexInputContainer>
      </ColorPickerContainer>
    </>
  );
};

export default CustomPicker(MyPicker);
